import React from 'react';
import { Box, Typography } from '@mui/material';
import {
    GestionFermetureEtablissementWidget,
    GestionFermetureEtablissementWidgetType,
} from '../../molecules';

export type GestionFermetureEtablissementListProps = {
    items?: Array<GestionFermetureEtablissementWidgetType>;
};

export const GestionFermetureEtablissementList: React.FunctionComponent<GestionFermetureEtablissementListProps> =
    function (props: GestionFermetureEtablissementListProps) {
        const { items } = props;

        if (!items || items.length === 0) {
            return (
                <Typography
                    variant="body1"
                    sx={{ marginTop: '16px', color: 'text.secondary', fontStyle: 'italic' }}
                >
                    Aucun établissement secondaire existant
                </Typography>
            );
        }

        const hasClosedEtablissement = items.some(
            (item) =>
                item.gestionFermetureEtablissement?.personneMorale?.autresEtablissements
                    ?.descriptionEtablissement?.dateEffetFermeture,
        );

        const visibleItems = hasClosedEtablissement
            ? items
                  .map((item, originalIndex) => ({ item, originalIndex }))
                  .filter(
                      ({ item }) =>
                          item.gestionFermetureEtablissement?.personneMorale?.autresEtablissements
                              ?.descriptionEtablissement?.dateEffetFermeture,
                  )
            : items.map((item, originalIndex) => ({ item, originalIndex }));

        return (
            <Box>
                {visibleItems.map(({ item: itemProps, originalIndex }) => (
                    <GestionFermetureEtablissementWidget
                        key={`gestionFermetureEtablissement-${originalIndex}`}
                        {...itemProps}
                        index={originalIndex}
                    />
                ))}
            </Box>
        );
    };
